import { render, staticRenderFns } from "./typeManage.vue?vue&type=template&id=0e350c2e&scoped=true"
import script from "./typeManage.vue?vue&type=script&lang=js"
export * from "./typeManage.vue?vue&type=script&lang=js"
import style0 from "./typeManage.vue?vue&type=style&index=0&id=0e350c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e350c2e",
  null
  
)

export default component.exports